export const RECEIVE_COMPANIES = 'session/receive-companies';
export const RECEIVE_SESSION = 'session/receive-session';
export const SET_ACCOUNTS='session/set-accounts';
export const SET_AVATAR='session/set-avatar';
export const SET_DATA_COMPANY = 'session/set-data-company';
export const SET_DATA_USER = 'session/set-data-user';
export const SET_PARAMETERS = 'session/set-parameters';